import { render, staticRenderFns } from "./AllServices.vue?vue&type=template&id=42b2fda4&"
import script from "./AllServices.vue?vue&type=script&lang=js&"
export * from "./AllServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports